import { TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledGroupRow = styled(TableRow)`
  td {
    padding: 0.5rem 1rem;

    &:hover {
      cursor: default !important;
      background-color: transparent;
    }
  }
`;